<template>
  <v-container fluid class="bio-container pa-4">
    <v-row>
      <v-col cols="12" md="4">
        <v-img
          src="@/assets/2025A87_401_HR.jpeg"
          alt="Author headshot"
          class="headshot"
        />
      </v-col>
      <v-col cols="0" md="1" />
      <v-col cols="12" md="6" class="bio">
        <!-- Intro Paragraph -->
        <p class="body-1 mb-6">
          Kassandra Jo Tomaras is a New Yorker, a mother, a writer, and a
          literary translator. She has published literary criticism, personal
          essays, short speculative fiction, and translations of fantasy stories
          by the Yiddish author Der Nister.
        </p>

        <v-divider class="my-6 divider" />

        <!-- Call‑out Box for Featured Projects -->
        <div class="callout mb-6">
          <p class="body-1 mb-0">
            Kassandra Jo Tomaras is a queer trans woman. Her current projects
            include <em>Attack Helicopter Mother</em>, a collection of personal
            essays about transgender motherhood; and <em>Imagined</em>, a
            collection of translations of short stories first published by
            Der Nister in the 1920s.
          </p>
        </div>

        <v-divider class="my-6 divider" />

        <!-- Closing Paragraph -->
        <p class="body-1 mb-6">
          She is represented by Rach Crawford at Wolf Literary Services. For all
          inquiries, please contact rachel (at) wolflit (dot) com.
        </p>
      </v-col>
      <v-col cols="0" md="1" />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AuthorBio",
};
</script>

<style scoped>
/* Page background */
.bio-container {
  background-color: #f0e6d2; /* Cream */
}

/* Headshot styling */
.headshot {
  border: 4px solid #cac4c3; /* Warm Gray */
  border-radius: 12px;
}

/* Main text color */
.bio .body-1 {
  color: #3e3e3e; /* Charcoal */
}

/* Divider color */
.divider {
  background-color: #cac4c3 !important; /* Warm Gray */
  height: 1px;
}

/* Call‑out box using secondary accent */
.callout {
  background-color: #d6e6d0; /* Sage Green */
  padding: 16px;
  border-radius: 8px;
  color: #ffffff;
}

/* Link styles */
.bio a {
  color: inherit;
  text-decoration: underline;
}
.bio a:hover {
  color: #c8a2c8; /* Lilac */
}

/* Responsive image adjustments */
@media (max-width: 600px) {
  .headshot {
    width: 100%;
    height: auto;
    transform: none;
  }
  .bio {
    margin-top: 50px;
  }
}

@media (min-width: 600px) {
  .headshot {
    transform: scale(0.7);
  }
  .bio {
    margin-top: -70px;
  }
}

@media (min-width: 960px) {
  .headshot {
    margin-top: 75px;
    transform: scale(1.2);
  }
  .bio {
    margin-top: 50px;
  }
}

/* Larger breakpoints inherit default spacing */
</style>
